"use client";

import { useEffect } from "react";
import type { AwsRum, AwsRumConfig } from "aws-rum-web";

declare global {
  interface Window {
    awsRum?: AwsRum;
    awsRumInitializing?: Promise<void>;
  }
}

const config: AwsRumConfig = {
  sessionSampleRate: 1,
  endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
  telemetries: ["performance", "errors", "http"],
  allowCookies: true,
  enableXRay: false,
  signing: false,
};

const APPLICATION_ID = "a37fbf71-c28f-4523-bcba-49e2cdf74498";
const APPLICATION_VERSION = "1.0.0";
const APPLICATION_REGION = "us-east-1";

async function initializeCloudWatchRUM() {
  if (window.awsRum) return;

  const { AwsRum } = await import("aws-rum-web");
  window.awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config,
  );
}

export default function CloudWatchRUMClient() {
  useEffect(() => {
    window.awsRumInitializing ??= initializeCloudWatchRUM().catch((error) => {
      window.awsRumInitializing = undefined;
      console.error("CloudWatch RUM initialization failed", error);
    });
  }, []);

  return null;
}